import React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import SearchType, {
    BulkSearchProductRequest, GetBulkProductSearchDataResponse,
} from "src/model/ProductMatch";
import MetricsUtil, {ActionName} from "src/utils/MetricsUtil";
import ApplicationState from "src/model/ApplicationState";
import {KatBox, KatButton, KatDropdown, KatIcon, KatInput, KatOption} from "@amzn/katal-react";
import {getCountryListConfig} from "src/config/Config";
import RequestStatus from "src/model/RequestStatus";
import {setBulkProductDataQueryStart} from "src/actions/BulkProductSearchAction";

interface StateProps {
    bulkProductSearchRes: GetBulkProductSearchDataResponse,
}

interface OwnProps {
    readonly currentCountryCode: string,
    readonly metricsUtil?: MetricsUtil,
    handleCountryChange: (countryCode: string) => void
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    bulkProductSearchRes: state.bulkProductSearchRes,
});

interface DispatchProps {
    readonly dispatchGetProduct: (request: BulkSearchProductRequest) => void,
}

const mapDispatchToProps = (dispatch: Dispatch) => (
    bindActionCreators({
        dispatchGetProduct: setBulkProductDataQueryStart,
    }, dispatch)
);

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = StateProps & OwnProps & DispatchProps & WithTranslation;

interface State {
    searchKey: string,
}

export class SearchAmznProductBarComponent extends React.Component<Props, State> {

    protected readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);

        this.state = {
            searchKey: '',
        };

        this.handleKeyup = this.handleKeyup.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.doSubmit = this.doSubmit.bind(this);
        this.handleKeyChange = this.handleKeyChange.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);


        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    handleKeyChange(event: KatInput.ChangeEvent) {
        this.setState({searchKey: event.currentTarget.value});
        this.publishCounter("searchKey", "input");
    }

    handleChangeCountry(event: KatDropdown.ChangeEvent) {
        this.props.handleCountryChange(event.detail.value);
        this.publishCounter("existingProduct_countryCode", "select");
    }

    publishCounter(method: string, counter: string) {
        if (this.metricsUtil) {
            this.metricsUtil.publishCounter(method, counter);
        }
    }

    handleKeyup(event: KatInput.KeyupEvent) {
        let key = (event as unknown as KeyboardEvent).key;
        if (key === "Enter" || key === "NumpadEnter") {
            event.preventDefault();
            this.doSubmit();
        }
    }

    handleSubmit(event: React.FormEvent) {
        event.preventDefault();
        this.doSubmit();
    }

    doSubmit() {
        const countryCode = this.props.currentCountryCode;
        const searchKey = this.state.searchKey;

        if (this.metricsUtil) {
            this.metricsUtil.publishCounter("searchButton", "click",);
            this.metricsUtil.setLongTimer(ActionName.TIME_ON_PAGE_AFTER_PRODUCT_SEARCHING_OR_SELECTING);
        }
        if (!countryCode || !searchKey.trim()) {
            return;
        }
        this.props.dispatchGetProduct({pageOffset: 1, searchType: SearchType.GENERAL, countryCode: countryCode, keywords: searchKey});
    }

    render() {
        const {t} = this.props;
        const countryCode = this.props.currentCountryCode;

        return (
            <>
                <KatBox variant="ltgrey">
                    <form id="ProductSearchInput" onSubmit={this.handleSubmit} className="product-search-input">
                        <KatDropdown richSelectionLabel label={t('SC_FBA_Calc_label_country')} value={countryCode}
                                     className="dropdown-country" onChange={this.handleChangeCountry}>
                            {
                                getCountryListConfig().map((country, index) => (
                                    <KatOption value={country} key={index}>
                                        <div className="flexed">
                                            <KatIcon name={("flag-" + country.toLowerCase()) as KatIcon.Name} size="small"/>
                                            <span className="paddedMedium">{country}</span>
                                        </div>
                                    </KatOption>
                                ))
                            }
                        </KatDropdown>
                        <KatInput label={t('SC_FBA_Calc_label_search')} tooltipText={t('SC_FBA_Calc_tip_searchAction')}
                                  placeholder={t('SC_FBA_Calc_tip_search')} className="input-asin" onChange={this.handleKeyChange}
                                  onKeyup={this.handleKeyup}/>

                        <KatButton label={t('SC_FBA_KnightsSearchButtonLabel_35008')} variant="primary" type="submit"
                                   disabled={this.props.bulkProductSearchRes.requestStatus === RequestStatus.LOADING}
                                   className="button-search"/>
                    </form>
                </KatBox>
            </>
        );
    }
}

export default withTranslation()(connector(SearchAmznProductBarComponent));
